const updateItems = [
  { date: '07-30', title: '《孤注一掷》高清版上线', tag: '新片上线', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-30', title: '《庆余年2》更新至第36集', tag: '剧集更新', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-29', title: '《歌手2025》总决赛完整版', tag: '综艺更新', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-29', title: '《封神第二部》1080P修复版', tag: '高清修复', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-28', title: '《海贼王》更新至第1120集', tag: '动漫更新', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-28', title: '《三大队》电视剧版全集上线', tag: '新片上线', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-27', title: '《周处除三害》全网首播', tag: '新片上线', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-27', title: '《乘风破浪的姐姐》新一期', tag: '综艺更新', tagColor: 'bg-secondary-100 text-secondary-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">最新更新</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">实时追踪影视资源更新动态，不错过任何一部好片</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200 space-y-6">
            {updateItems.map((item, idx) => (
              <div key={idx} className="relative group cursor-pointer">
                <div className="absolute -left-[33px] top-1 w-4 h-4 rounded-full bg-background-50 border-2 border-primary-400 group-hover:bg-primary-500 transition-colors"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="text-xs font-medium text-foreground-500 whitespace-nowrap">{item.date}</span>
                  <span className={`text-xs px-2 py-0.5 rounded font-medium w-fit whitespace-nowrap ${item.tagColor}`}>{item.tag}</span>
                  <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">{item.title}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}